module.exports = __webpack_public_path__ + "img/gather_sleeve_ruffle.f6d06cd3.png";